// extracted by mini-css-extract-plugin
export default {"questionHeader":"styles_questionHeader__CFL91","pageContent":"styles_pageContent__cb4Pa"};